import { Link } from "react-router-dom";
import { WORD_PACKS } from "../data/word-packs";
import { listCustomPacks } from "../local/customPacks";
import { GameImage } from "../game/ui/GameImage";

/**
 * Printable flashcards for teachers — one A4 page per word pack, each card
 * showing the picture (Fluent 3D emoji, OpenMoji fallback) with the English
 * word underneath. Built-in packs first, then any teacher-made custom packs.
 *
 * The teacher hits Print (or ⌘P / Ctrl-P); the `@media print` rules in
 * ui-system.css hide the app chrome and force one pack per page.
 */
export function Printables() {
  const packs = [...WORD_PACKS, ...listCustomPacks()];

  return (
    <div className="printables">
      <div className="printables-toolbar">
        <Link to="/teacher" className="btn btn-ghost">← Back</Link>
        <h1 className="printables-title">Printable Flashcards</h1>
        <button className="btn btn-green" onClick={() => window.print()}>🖨 Print</button>
      </div>
      <p className="printables-hint">
        One page per word pack — each card has the picture with the English word
        underneath. Press <strong>Print</strong> (or ⌘P / Ctrl-P), pick your
        printer, turn on “Background graphics” for full colour, then cut along
        the dashed lines.
      </p>

      <div className="printables-sheets">
        {packs.map((pack) => (
          <section key={pack.id} className="print-sheet">
            <header className="print-sheet-head">
              <h2>{pack.title}</h2>
              <span>{pack.subtitle}</span>
            </header>
            <div className="print-card-grid">
              {pack.words.map((word) => (
                <div key={word.id} className="print-card">
                  <div className="print-card-pic">
                    <GameImage
                      src={word.imageUrl}
                      alt={word.english}
                      className="print-card-img"
                      fallbackLabel={(word.english[0] ?? "?").toUpperCase()}
                    />
                  </div>
                  <div className="print-card-word">{word.english}</div>
                </div>
              ))}
            </div>
            <footer className="print-sheet-foot">Word Runner · {pack.title}</footer>
          </section>
        ))}
      </div>
    </div>
  );
}
